import MyButton from "@/components/UI/MyButton";
import MyDialog from "@/components/UI/MyDialog";
import MyVk from "@/components/UI/MyVk";
import MyTelegram from "@/components/UI/MyTelegram";

export default [MyButton, MyDialog, MyVk, MyTelegram];
